import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Grid, Image, Link, Text,
} from '@domain-group/suit-theme'

import { UseCarouselPayload } from '@hooks/useCarousel'

import type { UseCampaignPayload } from '@hooks/useCampaign'
import type { ImageModel } from '@models/types'

type DefaultState = {
  gridView: boolean,
  showMedia: boolean,
}

type SetState = (state: Partial<DefaultState>) => void

interface MediaGridProps {
  callbacks: {
    downloadMedia: UseCampaignPayload['callbacks']['downloadMedia'],
    setSelectedIndex: UseCarouselPayload['callbacks']['setSelectedIndex'],
    setState: SetState,
  },
  filteredImages: ImageModel[],
}

const MediaGrid = (props: MediaGridProps) => {
  const { callbacks: { downloadMedia, setSelectedIndex, setState }, filteredImages } = props

  return (
    <Box>
      <Grid
        // @ts-expect-error TS2322
        paddingX="large"
        gridGap="medium"
        gridAutoRows="1fr"
        gridTemplateColumns={['repeat(auto-fill, minmax(160px, 1fr))', '1fr 1fr 1fr']}
        gridTemplateRows={['repeat(auto-fill, minmax(150px, 1fr))', 'repeat(auto-fill, minmax(200px, 1fr))']}
      >
        {filteredImages.map((image, index) => (
          <Box
            border="1px solid"
            borderColor="lineColor"
            borderRadius="5px"
            flexDirection="column"
            key={`image-${image.id}`}
            overflow="hidden"
          >
            <Link
              onClick={() => {
                setState({
                  gridView: false,
                  showMedia: true,
                })
                setSelectedIndex(index)
              }}
              style={{
                textDecoration: 'none',
              }}
            >
              <Image url={image.original_url} height="180px" />
            </Link>

            <Box
              alignItems="center"
              backgroundColor="white"
              flexDirection="row"
              justifyContent="space-between"
              padding="large"
            >
              <Box
                flexDirection="column"
                overflow="hidden"
              >
                <Text fontSize="small" style={!image.id_code ? { height: '14px' } : undefined}>{image.id_code}</Text>

                <Text
                  color="bodyFontLightColor"
                  fontSize="xsmall"
                  marginTop="small"
                  variant="ellipsis"
                >
                  {image.file_file_name}
                </Text>
              </Box>

              <Button
                buttonStyle="secondaryUtility"
                height="30px"
                icon={<FontAwesomeIcon icon={faDownload} />}
                onClick={() => downloadMedia([image.id])}
                size="small"
                style={{
                  border: 'none',
                }}
                width="30px"
              />
            </Box>
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export default MediaGrid
